import ContentHeader from "../../../../layout/ContenteHeader";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHandshake } from "@fortawesome/free-solid-svg-icons";

const JobHeader = () => {
  return (
    <ContentHeader>
      <div style={{ display: "flex", alignItems: "center", gap: "14px" }}>
        <div style={{
          width: "46px",
          height: "46px",
          borderRadius: "12px",
          background: "linear-gradient(135deg, #f57c00 0%, #e65100 100%)",
          color: "#fff",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontSize: "1.2rem",
          flexShrink: 0,
          boxShadow: "0 4px 12px rgba(245,124,0,0.3)",
        }}>
          <FontAwesomeIcon icon={faHandshake} />
        </div>
        <div>
          <div style={{ fontSize: "1.5rem", fontWeight: 800, color: "#212121", lineHeight: 1.2 }}>
            Outsourcing
          </div>
          <div style={{ fontSize: "0.85rem", color: "#9e9e9e", marginTop: "2px" }}>
            Post and manage outsourcing jobs
          </div>
        </div>
      </div>
    </ContentHeader>
  );
};

export default JobHeader;
